
import { defineComponent } from 'vue';
import { mapState } from 'vuex';
import moment from 'moment';
import numeral from 'numeral';
import Banner from '@/components/banner/Banner.vue';
import BackArrowIcon from '@/components/icons/BackArrowIcon.vue';
import DownloadIcon from '@/components/icons/DownloadIcon.vue';
import {
  getLogisticsRelList,
  getLogisticsDetail,
  getLogisticsBatchList
} from '@/api/apis';
import { downloadFile } from '@/api/request';
import { baseUrl } from '@/utils/constants';

interface PartLogisticsDetailProps {
  dataSource: any[];
  batches: any[];
  orderNums: any[];
  detail: any;
  [key: string]: any;
}

export default defineComponent({
  name: 'PartLogisticsDetail',
  components: {
    Banner,
    BackArrowIcon,
    DownloadIcon
  },
  data(): PartLogisticsDetailProps {
    return {
      numeral,
      moment,
      loading: false,
      colTitle: [
        'part_type',
        'part_name',
        'part_no',
        'part_code',
        'unit',
        'unit_price',
        'total_price',
        'quantity',
        'remark'
      ],
      columns: [
        {
          dataIndex: 'groupName',
          width: 120,
          slots: { title: 'part_type-title', customRender: 'groupName' }
        },
        {
          dataIndex: 'name',
          width: 100,
          slots: { customRender: 'name', title: 'part_name-title' }
        },
        {
          dataIndex: 'modelNum',
          width: 100,
          slots: { title: 'part_no-title' }
        },
        {
          dataIndex: 'partCode',
          width: 100,
          slots: { title: 'part_code-title' }
        },
        {
          dataIndex: 'unit',
          width: 100,
          slots: { customRender: 'unit', title: 'unit-title' }
        },
        {
          dataIndex: 'deliverQuantity',
          width: 100,
          slots: { customRender: 'quantity', title: 'quantity-title' }
        },
        {
          dataIndex: 'sellingPrice',
          width: 100,
          slots: { customRender: 'unitPrice', title: 'unit_price-title' }
        },
        {
          dataIndex: 'totalPrice',
          width: 100,
          slots: { customRender: 'totalPrice', title: 'total_price-title' }
        },
        {
          title: this.$t('order.remark'),
          width: 100,
          dataIndex: 'remark',
          slots: { title: 'remark-title' }
        }
      ],
      dataSource: [],
      batches: [],
      ipagination: {
        current: 1,
        pageSizeOptions: ['5', '10', '15'],
        total: 6,
        showSizeChanger: true,
        pageSize: 5,
        showQuickJumper: true
        // size: 'large'
      },
      id: 0,
      orderNums: [],
      detail: {}
    };
  },
  created() {
    const id = +(this.$route.params.id as string);

    if (!isNaN(id) && id > 0) {
      this.id = id;

      this.loadData();
    }
  },
  computed: {
    ...mapState(['lang'])
  },
  methods: {
    async handleDownload() {
      await downloadFile(
        `${baseUrl}ureport/excel?_u=db:user_parts_logistics_detail_excel.ureport.xml&logisticsId=${this.id}&locale=${this.lang}`,
        this.$t('order.part_logistics_title') + '.xlsx',
        null
      );
    },
    async loadData() {
      const res = await Promise.all([
        getLogisticsDetail({ id: this.id }),
        getLogisticsRelList({ logisticsId: this.id })
      ]);

      if (res && res.length === 2 && res.every(s => s.success)) {
        this.detail = res[0].result || {};

        this.batches = res[1].result || [];
      }

      this.orderNums = this.batches.map(s => s.orderNum);

      await this.loadGridData();
    },
    async loadGridData() {
      this.loading = true;

      const res = await getLogisticsBatchList({
        pageNo: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
        logisticsId: this.id,
        orderNums: this.orderNums.join(',')
      });

      if (res.success) {
        this.ipagination.total = res.result.total;
        this.dataSource = res.result.records || [];
      }

      this.loading = false;
    },
    onShowSizeChange(current) {
      this.ipagination.current = current;
      this.loadGridData();
    },
    onChange(page, pageSize) {
      this.ipagination.current = page;
      this.ipagination.pageSize = pageSize;
      this.loadGridData();
    },
    handleCheckChange() {
      if (this.batches.length === this.batches.filter(s => !s.checked).length) {
        this.orderNums = this.batches.map(s => s.orderNum);
      } else {
        this.orderNums = this.batches
          .filter(s => s.checked)
          .map(s => s.orderNum);
      }

      this.loadGridData();
    },
    handleBack() {
      // this.$router.push('/order?tab=3');
      this.$router.back();
    }
  }
});
